module.exports = __webpack_public_path__ + "img/no_notice.9dc83de7.svg";